module.exports = __webpack_public_path__ + "static/media/eob-vs-bill.8abeaabc.svg";